import React, { useEffect, useState } from "react";
import { useAuth } from "../auth/useAuth";
import { useNavigate } from "react-router-dom";
import "../styles/NotificationsPage.css";

const API = "https://squid-app-6s2hc.ondigitalocean.app";

export default function NotificationsPage() {

  const { user } = useAuth();
  const navigate = useNavigate();

  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  const [replyingTo, setReplyingTo] = useState("");
  const [replyText, setReplyText] = useState("");
  const [sendingReply, setSendingReply] = useState(false);

  const [broadcastOpen, setBroadcastOpen] = useState(false);
  const [broadcastText, setBroadcastText] = useState("");
  const [sendingBroadcast, setSendingBroadcast] = useState(false);
  const [recipientType, setRecipientType] = useState("all");
  const [recipientUsername, setRecipientUsername] = useState("");

  // mobile menu
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  const go = (path) => () => {
    setMobileNavOpen(false);
    navigate(path);
  };

  const handleHome = go("/home-page");
  const handleDiscover = go("/discover");
  const handleProfile = go("/profile");
  const handleMessages = go("/notifications");
  const handleContact = go("/contact");
  const openLearnMore = go("/about");

  const replyTo = (username) => {
  setReplyingTo(username);
  setReplyText("");
};

const deleteMessage = async (messageId) => {

  await fetch(
    `${API}/delete-message`,
    {
      method:"POST",
      credentials:"include",
      headers:{
        "Content-Type":"application/json"
      },
      body:JSON.stringify({
        messageId
      })
    }
  );

  setMessages(
    messages.filter(
      m => m._id !== messageId
    )
  );

};

const sendReply = async () => {

  if (!replyText.trim()) return;

  setSendingReply(true);

  try {

    const res = await fetch(
      `${API}/send-message`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          recipientUsername: replyingTo,
          message: replyText,
          email: user.email
        })
      }
    );

    const data = await res.json();

    if (res.ok && data.success) {
      setReplyingTo("");
      setReplyText("");
    }

  } finally {
    setSendingReply(false);
  }

};

const sendBroadcast = async () => {

  if (!broadcastText.trim()) return;

  setSendingBroadcast(true);

  try {

    const res = await fetch(
      `${API}/broadcast-message`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({

  message: broadcastText,

  recipientUsername:
    recipientType === "single"
      ? recipientUsername
      : ""

})
      }
    );

    const data = await res.json();

    if (res.ok && data.success) {

      alert(
        `sent to ${data.sent} users`
      );

      setBroadcastOpen(false);
      setBroadcastText("");

    }

  } finally {

    setSendingBroadcast(false);

  }

};

useEffect(() => {

  async function loadMessages() {

    // first check AuthContext
    if (user?.email) {

      try {

        const res = await fetch(
          `${API}/get-messages`,
          {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              email: user.email
            })
          }
        );

        if (res.ok) {

          const data = await res.json();

          setMessages(data.messages || []);

          await fetch(
            `${API}/mark-messages-read`,
            {
              method: "POST",
              credentials: "include",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                email: user.email
              })
            }
          );

          setLoading(false);

          return;

        }

      } catch {}
    }

    // fallback to whoami
    try {

      const whoamiRes = await fetch(
        `${API}/whoami`,
        {
          credentials: "include"
        }
      );

      const whoami = await whoamiRes.json();

      if (whoami.loggedIn) {

        const res = await fetch(
          `${API}/get-messages`,
          {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              email: whoami.email
            })
          }
        );

        const data = await res.json();

        setMessages(data.messages || []);

        setLoading(false);

        return;

      }

    } catch {}

    // last resort
    navigate("/returning");

  }

  loadMessages();

}, [user, navigate]);

  if (loading) {
    return (
      <div className="messages-container">
        loading...
      </div>
    );
  }

  return (
    <div className={`nav-shell ${mobileNavOpen ? "nav-shell--open" : ""}`}>

      <div
        className={`menu-overlay ${mobileNavOpen ? "open" : ""}`}
        onClick={() => setMobileNavOpen(false)}
      />

      <aside className={`slide-menu ${mobileNavOpen ? "open" : ""}`}>

        <button
          className="menu-close"
          onClick={() => setMobileNavOpen(false)}
        >
          ×
        </button>

        <nav className="menu-nav">

           <button onClick={handleHome}>
            home
          </button>


          <button onClick={handleProfile}>
            profile
          </button>


          <div className="menu-divider" />

           <button onClick={handleDiscover}>
            browse collections
          </button>

          <button onClick={openLearnMore}>
            learn more
          </button>

          <button onClick={handleContact}>
            contact t.c.p.
          </button>

        </nav>

      </aside>

      {!mobileNavOpen && (
        <header className="nav-burger-wrap">

          <button
            type="button"
            className="nav-burger"
            onClick={() => setMobileNavOpen(true)}
          >
            ☰
          </button>

        </header>
      )}

      <main className="messages-container">

       {
user?.username === "shaq"
&&
user?.email === "shaq@thecollectorsplatform.com"
&& (
  <button
    className="message-action-btn"
    onClick={() => setBroadcastOpen(true)}
  >
    broadcast message
  </button>

)}

        <h1 className="messages-title">
          inbox
        </h1>

        {messages.length === 0 ? (

          <div className="messages-empty">
            you have no new messages
          </div>

       ) : (

  <>

  {messages.map((m) => (

  <div
    key={m._id}
    className="message-card"
  >

 <div className="message-from">

  from{" "}

  <span
    className="message-profile-link"
    onClick={() =>
      navigate(`/u/${m.senderUsername}`)
    }
  >
    @{m.senderUsername}
  </span>

</div>
    <div className="message-date">
      {new Date(m.createdAt).toLocaleString([], {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      })}
    </div>

    <div
  className="message-body"
  dangerouslySetInnerHTML={{
    __html: m.message
  }}
/>

    <div className="message-actions">

      <button
        className="message-action-btn"
        onClick={() => replyTo(m.senderUsername)}
      >
        reply
      </button>

      <button
        className="message-action-btn delete"
        onClick={() => deleteMessage(m._id)}
      >
        delete
      </button>

    </div>

  </div>

))}

 {replyingTo && (

<div
    className="vc-modal-overlay"
    onClick={() => setReplyingTo("")}
>

<div
    className="vc-modal"
    onClick={(e)=>e.stopPropagation()}
>

<button
    className="vc-modal-close"
    onClick={() => setReplyingTo("")}
>
    ×
</button>

<p className="vc-modal-title">
    reply to @{replyingTo}
</p>

<div className="vc-contact-form">

<textarea
    className="vc-share-input"
    rows={8}
    placeholder="insert your message here"
    value={replyText}
    onChange={(e)=>setReplyText(e.target.value)}
/>

<button
    className="vc-share-copy"
    onClick={sendReply}
    disabled={sendingReply}
>
    {sendingReply ? "sending..." : "send"}
</button>

</div>

</div>

</div>

)}
  </>

)}
{broadcastOpen && (

<div
  className="vc-modal-overlay"
  onClick={() => setBroadcastOpen(false)}
>

<div
  className="vc-modal"
  onClick={(e) => e.stopPropagation()}
>

<button
  className="vc-modal-close"
  onClick={() => setBroadcastOpen(false)}
>
  ×
</button>

<label>
  <input
    type="radio"
    checked={recipientType === "all"}
    onChange={() => setRecipientType("all")}
  />
  all collectors
</label>

<label>
  <input
    type="radio"
    checked={recipientType === "single"}
    onChange={() => setRecipientType("single")}
  />
  specific collector
</label>

{recipientType === "single" && (

  <input
    className="vc-share-input"
    placeholder="@username"
    value={recipientUsername}
    onChange={(e) =>
      setRecipientUsername(e.target.value)
    }
  />

)}

<div className="vc-contact-form">

<textarea
  className="vc-share-input"
  rows={8}
  placeholder="write your update..."
  value={broadcastText}
  onChange={(e)=>setBroadcastText(e.target.value)}
/>

<button
  className="vc-share-copy"
  onClick={sendBroadcast}
 disabled={

  sendingBroadcast ||

  !broadcastText.trim() ||

  (
    recipientType === "single" &&
    !recipientUsername.trim()
  )

}
>
  {
sendingBroadcast
  ? "sending..."
  : recipientType === "all"
      ? "send to all"
      : "send to collector"
}
</button>

</div>

</div>

</div>

)}
      </main>

    </div>
  );

}